
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';

@Component
export default class CallBack extends Vue {
  public formTitle = 'نتیجه پرداخت';
  public desserts = [];
  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'گزارش وضعیت پرداخت',
      disabled: true,
      href: ''
    }
  ];

  async created() {
    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getWalletPayment(this.$route.query.Id as any).then((response: any) => {
      this.desserts = response.data;
      this.$hideLoading();
    });
  }

  async close() {
    this.$router.replace({ name: 'Home' });
  }

  getColor(paymentStatus: string) {
    if (paymentStatus === 'پرداخت شده') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
